import React, {useState,useEffect} from 'react'
import Form from './FormCategoria'
import Header from '../Header'

import { useParams } from "react-router-dom";

import {$http} from '../../helpers'
import {loading,warning,success} from '../../helpers/alerts'
import { useHistory } from "react-router-dom";

import {
    Card,
    Container
} from 'react-bootstrap'

const Editar = props => {

    const [state,setState] = useState({
        loading: false
    })
    const [categoria,setCategoria] = useState({
        titulo: '',
        visivel: 'SIM'
    })

    let params = useParams();
    let history = useHistory();

    const save = async (data) => {
        setCategoria(data)

        try{

            loading('show')

            let result = await $http.post(`categorias`,data)

            if(result.status != 201) throw result.data

            await success({
                title: 'Salvo com sucesso'
            })

            history.push('/categorias')

        }catch(e){
            warning({
                title:'Houve alguma divergência',
                message: e
            })
        }
    }

    return (<>
        <Header />
        <Container style={{marginTop:10}}>
            <Card>
    <Card.Header>Nova categoria</Card.Header>
                <Card.Body>
                    {!state.loading ?
                    <Form data={categoria} onSave={save} />
                    :
                    'Carregando'
                    }
                </Card.Body>
            </Card>
        </Container>
    </>);
}

export default Editar;